<script setup lang="ts">
import './assets/style.scss'
import { useModel } from '../model/model.ts'
import { VIcons } from '@/shared/ui'
import { ObjectTypesDeleteButton } from '@/features/Manuals/ObjectTypesDelete'
import { useRoute, useRouter } from 'vue-router'
import { computed } from 'vue'

const { data, loadData, headers } = useModel()
const { isFetching } = loadData()

const router = useRouter()
const route = useRoute()

/**
 * Получаем ссылку для возврата к общему списку
 */
const backLink = computed(() => {
  return router.resolve({
    name: 'objects.groups.admin.config',
    params: {
      ...route.params,
      list: '',
    },
  })
})

/**
 * Получаем ссылку на создание
 */
const createLink = computed(() => {
  return router.resolve({
    name: 'objects.groups.admin.config',
    params: {
      ...route.params,
      action: 'create',
    },
  })
})

/**
 * Получаем ссылку на редактирование
 */
const editLink = (objectTypeId: number) => {
  return router.resolve({
    name: 'objects.groups.admin.config',
    params: {
      ...route.params,
      action: 'edit',
      entity_id: objectTypeId,
    },
  })
}
</script>

<template>
  <h2 class="mb-4 text_head">{{ $t('itf.object_types') }}</h2>

  <VDataTable
    :items="data"
    :loading="isFetching"
    :items-per-page-options="[10, 50, 100]"
    :items-per-page="50"
    :headers="headers"
  >
    <template #item.icon="{ item }">
      <VIcons :type="item.icon" /> <span class="text_small text_primary">({{ item.icon }})</span>
    </template>

    <template #item.action="{ item }">
      <div class="table__btn_left">
        <VTooltip location="top" :open-delay="500" :text="$t('itf.view')">
          <template #activator="{ props }">
            <VBtn :to="editLink(item.id)" icon density="compact" v-bind="props">
              <VIcons type="visibility" />
            </VBtn>
          </template>
        </VTooltip>

        <ObjectTypesDeleteButton :id="item.id" />
      </div>
    </template>
  </VDataTable>

  <div class="form__btn_left mt-4">
    <VBtn :to="createLink">{{ $t('itf.add') }}</VBtn>
    <VBtn :to="backLink" variant="tonal" color="default">{{ $t('itf.back') }}</VBtn>
  </div>
</template>
